export default "__VITE_ASSET__6wa85VQi__"